import { render, staticRenderFns } from "./Hobbies.vue?vue&type=template&id=b9f39f9c&"
import script from "./Hobbies.vue?vue&type=script&lang=js&"
export * from "./Hobbies.vue?vue&type=script&lang=js&"
import style0 from "./Hobbies.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports